export class EventInfo {
  eventName: string;
  eventAction: string;
  type: string;


  constructor(eventName: string, eventAction: string, type: string) {
    this.eventName = eventName;
    this.eventAction = eventAction;
    this.type = type;
  }

  public getEventName(): string {
    return this.eventName;
  }

  public getEvenAction(): string {
    return this.eventAction;
  }

  public getType(): string {
    return this.type;
  }
}
